module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"deleteModal\" title=\"Delete\" style=\"display: none; margin-top:10px;\">\r\n    <div class=\"row confirm-delete-top-section\">\r\n        <div class=\"col-md-2\" style=\"width: 20px;\">\r\n            <input type=\"radio\" name=\"toDelete\" id='deleteReport' value='deleteReport'/>\r\n        </div>\r\n        <div class=\" col-md-11\">\r\n            Delete the report\r\n        </div>\r\n    </div>\r\n    <div class=\"row confirm-delete-bottom-section\">\r\n        <div class=\"col-md-2\" style=\"width: 20px;\">\r\n        </div>\r\n        <div class=\" col-md-11\">\r\n            Delete the report including all versions.\r\n        </div>\r\n    </div>\r\n    <div id=\"deletePreviousPanel\" class=\"disabledPanel\">\r\n        <div class=\"row confirm-delete-top-section\">\r\n            <div class=\"col-md-2\" style=\"width: 20px;\">\r\n                <input type=\"radio\" name=\"toDelete\" id='deletePrevious' value='deletePrevious'/>\r\n            </div>\r\n            <div class=\" col-md-11\">\r\n                Delete previous versions\r\n            </div>\r\n        </div>\r\n        <div class=\"row confirm-delete-bottom-section\">\r\n            <div class=\"col-md-2\" style=\"width: 20px;\">\r\n            </div>\r\n            <div class=\" col-md-11\">\r\n                Keep the latest version of the report but delete all previous versions.\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}